import '@fontsource/noto-serif';
import '@fontsource/dm-sans';
import Provider from './src/providers/provider';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = Provider;
